import styles from './AdvSection.module.scss';

const AdvSection = () => {
    const topRowItems = ['Рентген?', 'Любим животных', 'Своя лаборатория', 'Профессиональная команда'];
    const middleRowItems = ['Новые препараты', 'Работаем в субботу', 'Любим животных', 'Индивидуальный подход'];
    const bottomRowItems = ['Современное оборудование', 'Любим животных', 'УЗИ', 'Своя ветаптека'];

    return (
        <section className={styles.section}>
            {/* Первая строка - движение вправо */}
            <div className={styles.row}>
                <div className={styles.marqueeContainer}>
                    <div className={`${styles.marquee} ${styles.marqueeRight}`}>
                        <div className={styles.marqueeContent}>
                            {[...topRowItems, ...topRowItems, ...topRowItems].map((item, index) => (
                                <span key={index} className={styles.tag}>
                  {item}
                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Вторая строка - движение влево */}
            <div className={styles.row}>
                <div className={styles.marqueeContainer}>
                    <div className={`${styles.marquee} ${styles.marqueeLeft}`}>
                        <div className={styles.marqueeContent}>
                            {[...middleRowItems, ...middleRowItems, ...middleRowItems].map((item, index) => (
                                <span key={index} className={styles.tag}>
                  {item}
                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Третья строка - движение вправо */}
            <div className={styles.row}>
                <div className={styles.marqueeContainer}>
                    <div className={`${styles.marquee} ${styles.marqueeRight}`}>
                        <div className={styles.marqueeContent}>
                            {[...bottomRowItems, ...bottomRowItems, ...bottomRowItems].map((item, index) => (
                                <span key={index} className={styles.tag}>
                  {item}
                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AdvSection;